import styled from "styled-components";
import CustomButton from "./common/customButton";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import UserIcon from "./icon/userIcon";
import { useEffect, useState } from "react";
import { URLSearchParams } from "url";
import TonginLogoIcon from "./icon/tonginLogo";
import CalendarModal from "./home/calendarModal";
import {
  filterOverPastContractList,
  getContractList,
} from "../API/AppRepository";
import IconWrapper from "./common/iconWrapper";

const Header = styled.div`
  position: fixed; /* 화면 상단에 고정 */
  top: 0; /* 최상단에 위치 */
  left: 0;
  width: 100%; /* 전체 너비 */
  z-index: 999; /* 다른 요소보다 위에 있도록 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: white;
  box-shadow: 1vw 1vw 1vw 1vw #adadad10;
  /* 모바일*/
  @media (max-width: 767px) {
    padding: 0px 20px;
    height: 40px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 0px 50px;
    height: 80px;
  }

  /* PC */
  @media (min-width: 1200px) {
    padding: 0px 80px;
    height: 150px;
  }
`;

const MainWrapper = styled.div`
  /* 모바일 */
  padding-top: 40px;

  @media (min-width: 768px) and (max-width: 1199px) {
    padding-top: 80px;
  }

  @media (min-width: 1200px) {
    padding-top: 150px;
  }
`;

const LeftBox = styled.div`
  display: flex;
  align-items: center;
  width: 20%;
  height: 100%;
`;
const MidBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  height: 100%;
`;

const MenuTabItem = styled.div`
  width: 16vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &&:hover {
    cursor: pointer;
  }
`;

const MenuTabTitle = styled.div<{ $selectedTab?: number; index?: number }>`
  width: 100%;
  color: ${(props) =>
    props.$selectedTab === props.index
      ? props.index === 3
        ? "#6AD959"
        : "#ff7f3b"
      : "#505050"};
  font-weight: ${(props) =>
    props.$selectedTab === props.index ? "700" : "400"};
  display: flex;
  justify-content: center;
  align-items: center;

  /* 모바일*/
  @media (max-width: 767px) {
    height: 40px;
    font-size: 12px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 60px;
    padding-top: 6px;
    font-size: 24px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 60px;
    padding-top: 6px;
    font-size: 34px;
  }
`;

const MenuTabTitle2 = styled.div<{}>`
  width: 100%;
  color: #242a30;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1vw;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
    font-weight: 600;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 30px;
    font-weight: 700;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 40px;
    font-weight: 700;
  }
`;

const MenuTabLine = styled.div<{ $selectedTab?: number; index?: number }>`
  width: 100%;
  height: 0.8vw;
  background-color: ${(props) =>
    props.$selectedTab === props.index
      ? props.index === 3
        ? "#6AD959"
        : "#ff7f3b"
      : "white"};
  border-radius: 2vw;
`;

const RightBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 20%;
  height: 100%;
  position: relative;
`;
const MyPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f3f3f3;
  &&:hover {
    cursor: pointer;
  }

  /* 모바일*/
  @media (max-width: 767px) {
    border-radius: 6px;
    width: 30px;
    height: 30px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    border-radius: 16px;
    width: 60px;
    height: 60px;
  }

  /* PC */
  @media (min-width: 1200px) {
    border-radius: 20px;
    width: 100px;
    height: 100px;
  }
`;

const AlertNumberBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.6vw;
  height: 3.6vw;
  background-color: #ff7f3b;
  position: absolute;
  right: 7vw;
  top: 0.6vw;
  color: white;
  border-radius: 100%;
`;

const MyMenuArea = styled.div`
  background-color: #fffffff4;
  width: 16vw;
  position: absolute;
  top: 8vw;
  right: 0.2vw;
  border-radius: 0.4vw;
  display: flex;
  flex-direction: column;
  padding: 1vw;
  border: 0.4vw solid #ff7f3b;
  z-index: 9999;
`;

const NameItem = styled.div`
  width: 100%;
  height: 3vw;
  display: flex;
  justify-content: end;
  padding-right: 1vw;
  border-bottom: 0.1vw solid #ff7f3b;
  font-size: 1.6vw;
  font-weight: 500;
  /* color: #ff7f3b; */
`;

const MenuItem = styled.div`
  margin-top: 1vw;
  width: 100%;
  height: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2vw;
  border-radius: 0.4vw;
  padding: 1vw;
  &&:hover {
    background-color: #ff7f3b;
    color: white;
    cursor: pointer;
  }
`;

const MenuItem2 = styled.div`
  margin-top: 1vw;
  width: 100%;
  height: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2vw;
  border-radius: 0.4vw;
  padding: 1vw;
  background-color: #ff7f3b;
  color: white;
  &&:hover {
    cursor: pointer;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
  pointer-events: none; /* 클릭 테스트용 */
`;

const HomeHeader = () => {
  const url = window.location.href;

  const navigate = useNavigate();

  const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<number>(1);
  const [contractList, setContractList] = useState<any[]>([]);
  const [overPastLsit, setOverPastList] = useState<any[]>([]);

  // 최초 데이터 가져와서 필터링
  useEffect(() => {
    const fetchAndFilterContracts = async () => {
      try {
        const response = await getContractList();
        if (response?.data?.receiptList) {
          const filteredList = filterOverPastContractList(
            response.data.receiptList
          );
          setOverPastList(filteredList);
        }
      } catch (error) {
        console.error("견적 리스트 조회 중 오류 발생:", error);
      }
    };

    fetchAndFilterContracts();
  }, []);

  useEffect(() => {
    if (url.includes("/contractlist")) {
      setSelectedTab(2);
      return;
    } else if (url.includes("/onsitecontract")) {
      setSelectedTab(3);
      return;
    } else if (url.includes("/enterpriseContractList")) {
      setSelectedTab(4);
      return;
    } else {
      setSelectedTab(1);
      return;
    }
  }, [url]);

  const logout = () => {
    if (window.confirm("로그아웃 하시겠습니까?")) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("loginUser");
      navigate("/login");
    }
  };

  const handleOverPastAlert = () => {
    alert(`      상담 7일 경과 후 아직까지 미계약상태로 
      남아있는 견적이 ${overPastLsit.length}건 있습니다.
      "계약" 혹은 "취소" 상태로 변경하세요.
      `);
  };

  const closeMenu = () => {
    setOpenMenu(false);
  };

  const goOnsitecontract = () => {
    navigate("/onsitecontract");
  };

  const goEnterpriseContractList = () => {
    navigate("/enterpriseContractList");
  };

  const goHome = () => {
    navigate("/");
  };

  const goContractList = () => {
    navigate("/contractlist");
  };

  const goProfile = () => {
    navigate("profile");
  };

  const doRefresh = () => {
    window.location.reload();
  };

  const handleOpenCalendar = () => {
    setOpenCalendar(true);
  };

  const closeCalendar = () => {
    setOpenCalendar(false);
  };

  return (
    <>
      {openMenu && <Backdrop onClick={closeMenu}></Backdrop>}
      {openCalendar && <CalendarModal onClose={closeCalendar}></CalendarModal>}

      {loginUser.userType === "mattress" && (
        <Header>
          <LeftBox onClick={goHome}>
            <TonginLogoIcon height={"100%"} />
          </LeftBox>
          <MidBox>
            <MenuTabTitle2>매트리스케어</MenuTabTitle2>
          </MidBox>
          <RightBox>
            <MyPage
              onClick={() => {
                setOpenMenu(!openMenu);
              }}
            >
              <UserIcon width={"70%"} fill={"#0C8CE9"} />
              {/* <AlertNumberBox>{overPastLsit.length}</AlertNumberBox> */}
              {openMenu && (
                <MyMenuArea>
                  <MenuItem onClick={doRefresh}>강력 새로고침</MenuItem>
                  <MenuItem onClick={goProfile}>프로필</MenuItem>
                  <MenuItem onClick={logout}>로그아웃</MenuItem>
                </MyMenuArea>
              )}
            </MyPage>
          </RightBox>
        </Header>
      )}

      {loginUser.userType === "plumber" && (
        <Header>
          <LeftBox onClick={goHome}>
            <TonginLogoIcon height={"100%"} />
          </LeftBox>
          <MidBox>
            <MenuTabTitle2>배관케어</MenuTabTitle2>
          </MidBox>
          <RightBox>
            <MyPage
              onClick={() => {
                setOpenMenu(!openMenu);
              }}
            >
              <UserIcon width={"70%"} fill={"#0C8CE9"} />
              {/* <AlertNumberBox>{overPastLsit.length}</AlertNumberBox> */}
              {openMenu && (
                <MyMenuArea>
                  <MenuItem onClick={doRefresh}>강력 새로고침</MenuItem>
                  <MenuItem onClick={goProfile}>프로필</MenuItem>
                  <MenuItem onClick={logout}>로그아웃</MenuItem>
                </MyMenuArea>
              )}
            </MyPage>
          </RightBox>
        </Header>
      )}

      {loginUser.userType !== "mattress" &&
        loginUser.userType !== "plumber" && (
          <Header>
            <LeftBox onClick={goHome}>
              <TonginLogoIcon height={"100%"} />
            </LeftBox>
            <MidBox>
              <MenuTabItem
                onClick={() => {
                  // setSelectedTab(1);
                  goHome();
                }}
              >
                <MenuTabTitle $selectedTab={selectedTab} index={1}>
                  홈
                </MenuTabTitle>
                <MenuTabLine $selectedTab={selectedTab} index={1}></MenuTabLine>
              </MenuTabItem>
              <MenuTabItem
                onClick={() => {
                  // setSelectedTab(2);
                  goContractList();
                }}
              >
                <MenuTabTitle $selectedTab={selectedTab} index={2}>
                  견적리스트
                </MenuTabTitle>
                <MenuTabLine $selectedTab={selectedTab} index={2}></MenuTabLine>
              </MenuTabItem>
              <MenuTabItem
                onClick={() => {
                  // setSelectedTab(3);
                  goOnsitecontract();
                }}
              >
                <MenuTabTitle $selectedTab={selectedTab} index={3}>
                  현장접수
                </MenuTabTitle>
                <MenuTabLine $selectedTab={selectedTab} index={3}></MenuTabLine>
              </MenuTabItem>
              {loginUser.isCompanyContractTeam && (
                <MenuTabItem
                  onClick={() => {
                    // setSelectedTab(4);
                    goEnterpriseContractList();
                  }}
                >
                  <MenuTabTitle $selectedTab={selectedTab} index={4}>
                    기업이전
                  </MenuTabTitle>
                  <MenuTabLine
                    $selectedTab={selectedTab}
                    index={4}
                  ></MenuTabLine>
                </MenuTabItem>
              )}
            </MidBox>
            <RightBox>
              <MyPage
                onClick={() => {
                  setOpenMenu(!openMenu);
                }}
              >
                <UserIcon width={"70"} fill={"#ff7f3b"} />
                <AlertNumberBox>{overPastLsit.length}</AlertNumberBox>
                {openMenu && (
                  <MyMenuArea>
                    <NameItem>{loginUser.name} 님</NameItem>
                    {overPastLsit.length > 0 && (
                      <MenuItem2 onClick={handleOverPastAlert}>
                        미계약 {overPastLsit.length}건
                      </MenuItem2>
                    )}
                    <MenuItem onClick={handleOpenCalendar}>손없는 날</MenuItem>
                    <MenuItem onClick={doRefresh}>강력 새로고침</MenuItem>
                    <MenuItem onClick={goProfile}>프로필</MenuItem>
                    <MenuItem onClick={logout}>로그아웃</MenuItem>
                  </MyMenuArea>
                )}
              </MyPage>
            </RightBox>
          </Header>
        )}
    </>
  );
};
export default function Layout() {
  return (
    <>
      <HomeHeader />
      <MainWrapper>
        <Outlet></Outlet>
      </MainWrapper>
    </>
  );
}
